import { render, staticRenderFns } from "./PositionFormLinks.vue?vue&type=template&id=15b6e8ec"
import script from "./PositionFormLinks.vue?vue&type=script&lang=js"
export * from "./PositionFormLinks.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports